import { Button, Popover } from "antd";
import styles from "./styles.module.scss";
import { ConditionalRenderer } from "components";
import { useRecoilState } from "recoil";
import { persistedUserOrStrikerId } from "store/atom";
import {
  AcceptRequestIcon,
  DeclineRequestIcon,
  DeleteStrikerIcon,
  InfoIcon,
  ViewStrikerIcon,
} from "icons";
import { statusTagsColors, statusTagslabels } from "../../constants";
import { maskEmail } from "utils/constants";
import { InfoCircleFilled } from "@ant-design/icons";
import { getInitialLetters } from "utils/helpers";

export const StrikerCard = ({ item, activeTab, userNotInDB }) => {
  let initalLetters = "";

  initalLetters = getInitialLetters(item?.username || item?.email);
  const bgColors = ["#B30086", "#EAC113", "#898989"];

  return (
    <div
      className={`${styles.cardContainer} ${
        activeTab !== "pending" ? styles.hoverCardContainer : null
      }`}
    >
      <div className={styles.dpAndInfo}>
        <div
          className={styles.image}
          style={{ backgroundColor: "rgb(126, 139, 159)" }}
        >
          {initalLetters}
        </div>
        <div
          className={styles.info}
          style={{ width: activeTab === "pending" && "14.6dvh" }}
        >
          <div className={styles.username}>{item.username}</div>
          <span title={item.email} className={styles.email}>
            {(!item.status || item.status === "not_connected") && !userNotInDB
              ? maskEmail(item.email)
              : item.email}
          </span>
          <div
            className={styles.tag}
            style={{ backgroundColor: statusTagsColors[item.status] }}
          >
            {statusTagslabels[item.status]}
          </div>
        </div>
      </div>
      <ConditionalRenderer condition={item.status === "connected"}>
        <div className={styles.icons}>
          <div
            className={styles.viewStriker}
            onClick={() =>
              window.open(`${window.location}?strikerId=${item?.userId}`)
            }
          >
            <ViewStrikerIcon />
          </div>
          <div className={styles.deleteStriker}>
            <DeleteStrikerIcon />
          </div>
        </div>
      </ConditionalRenderer>

      <ConditionalRenderer condition={item.status === "pending"}>
        <div className={styles.btns}>
          <AcceptRequestIcon />
          <DeclineRequestIcon />
        </div>
      </ConditionalRenderer>
      <ConditionalRenderer condition={item.status === "invited"}>
        <div className={styles.btns}>
          <button style={{ backgroundColor: "#7E8B9F", color: "white" }}>
            Cancel Invite
          </button>
        </div>
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={item.status === "not_connected" || !item.status}
      >
        <div className={styles.btns}>
          <ConditionalRenderer condition={userNotInDB}>
            <button style={{ backgroundColor: "#006AB3", color: "white" }}>
              Send Invite
            </button>
          </ConditionalRenderer>
          <ConditionalRenderer condition={!userNotInDB}>
            <button style={{ backgroundColor: "#006AB3", color: "white" }}>
              Connect
            </button>
          </ConditionalRenderer>

          {/* <ConditionalRenderer condition={item.role !== "striker"}>
            <Popover
              overlayInnerStyle={{ fontWeight: "bold" }}
              placement="bottom"
              content="Coaches can only connect with strikers"
            >
              <InfoIcon />
            </Popover>
          </ConditionalRenderer> */}
        </div>
      </ConditionalRenderer>
    </div>
  );
};
